import React, { useEffect, useState } from 'react'
import { useTranslate } from '../../../components/TranslationText';
import { useLocation, useNavigate } from 'react-router';
import NewActionButton from '../../../components/ActionButtons/NewActionButton';
import { aedLogoStyle, eFormButtonsContainer, eformFormButton, eformInput, eformTerms, getDirhamImage, iconContainer, showIconsContainer, termsTitle, whiteCard } from '../../../common/cssclasses';
import { formatDate } from '../../../helper/formatDate';
import EahsForm from '../../../components/EahsForm';
import NetaqInput from '../../../components/NetaqInput';
import axiosInstance from '../../../axios/axios';
import AsyncSelect from "react-select/async";
import { promiseOptions } from '../Api/semenMarketApi';
import { getCountries, getHorseColors } from '../../sharedAPI/lookUpApis';
import DynamicTableForm from '../Components/DynamicTableForm';
import SimpleUpload from '../../../components/SimpleFileUpload';
import CustomPopUp from '../../../components/CustomPopUp';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { ProgressBar } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/page-navigation/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/full-screen/lib/styles/index.css';
import { pdfjs } from 'react-pdf';
import SubmitServiceBtn from '../../../components/servicesButtons/SubmitServiceBtn';





export default function SemenCheckout({ toast }) {
    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        toolbarPlugin: {
            fullScreenPlugin: {
                getFullScreenTarget: (pagesContainer) => pagesContainer.closest('[data-testid="default-layout__body"]'),
                renderExitFullScreenButton: (props) => <></>,
            },
        },
    });
    const workerURl = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
    const BaseURL = process.env.REACT_APP_BASE_URL;
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isVIPHorse = searchParams.has("isVip") ? searchParams.get("isVip") : false;
    const { translate } = useTranslate();
    const navigate = useNavigate();
    const currentlang = localStorage.getItem('eahsLang') ?? 'en';
    const [horsePassport, setHorsePassport] = useState([]);
    const handleUpload = (e, setDate) => {
        if (e.target.files && e.target.files.length > 0) {
            let checkFileSize = true;
            const fileListHook = [];

            for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
                if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
                    checkFileSize = false;
                    toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
                } else {
                    // Check allowed file types
                    const file = e.target.files[fileIndex];
                    const allowedMimeTypes = ['image/', 'application/pdf'];

                    if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
                        toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
                        continue; // Skip to the next file if type is not allowed
                    }

                    fileListHook.push({
                        documentFile: URL.createObjectURL(e.target.files[fileIndex]),
                        name: e.target.files[fileIndex].name,
                        file: e.target.files[fileIndex],
                    });
                }
            }

            setDate(fileListHook);
        }
    };
    const accessToken = localStorage.getItem('accessTokenforEAHS') ?? '';


    const semen = {
        images: ['https://previews.123rf.com/images/siberian64/siberian642003/siberian64200300003/143675213-horses-in-the-meadow-livestock-in-the-countryside-aspect-ratio-16-9.jpg'],
        videos: ['https://www.youtube.com/embed/PXPxK-a7Lt0'],
        horseName: 'A.S. AL DHAHAB',
        gender: 'STALLION',
        birthDate: formatDate(new Date()),
        horseCategory: 'Show Horse',
        color: 'white',
        owner: 'SUMAYA HUSSAIN MOHAMMAD ABDULQADER ABBAS',
        address: 'Dubai, UAE',
        origin: 'Syria',
        ownerMail: 'summaya@mail.com',
        ownerPhone: '971504230624',
        price: 500,
        regNr: 123,
        sire: 'Sire Name',
        dam: 'Dam Name',

    }

    const yesNoOptions = [{ text: translate('web.yes', 'yes'), label: translate('web.yes', 'yes'), value: true }
        , { text: translate('web.no', 'no'), label: translate('web.no', 'no'), value: false }]
    const [mareData, setMareData] = useState({ isRegisterd: false, isForExport: false });
    const coveringCountryIsFrance = mareData?.coveringCountry == "37d328c5-2ee9-4581-1ceb-08dc12ef16d3";
    const [searchMare, setSearchMare] = useState('');
    const [selectedMare, setSelectedMare] = useState({});
    const [timeoutId, setTimeoutId] = useState(0);
    const [colors, setColors] = useState([]);
    const [countries, setCountries] = useState([]);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const handleChange = (e) => {
        setMareData({
            ...mareData,
            [e.target.name]: e.target.value
        })
    }

    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);

    const setPhoneNumber = (value) => {
        setMareData((prev) => ({
            ...prev,
            'Phone': value
        }));
    }

    useEffect(() => {
        getHorseColors().then(res => {
            setColors(res)
        })
        getCountries().then(res => {
            setCountries(res);
        })
    }, [])

    return (
        <div className='row'>
            <h2 className={termsTitle + " d-flex align-items-center flex-wrap mb-main"}>
                {!!semen?.regNr && semen.regNr + " - "} {semen?.horseName}

            </h2>
            <div className={showIconsContainer}>
                {detailsRow('fa fa-calendar', 'web.birthDate', semen?.birthDate, 'w-unset')}
                {detailsRow('fa fa-palette', 'web.color', semen?.color, 'w-unset')}
                {detailsRow('fa fa-earth-americas', 'web.origin', semen?.origin, 'w-unset')}
                <div className={iconContainer}>
                    <img src={getDirhamImage(currentlang)} alt='AED' style={aedLogoStyle} />
                    <span className='fw-bold'>{`${translate("web.price", "Price")}`} {semen?.price?.toLocaleString("en-US")} {translate('web.aed', 'AED')}</span>
                </div>
            </div>
            {!accessToken &&
                <EahsForm key={'Buyer Details'} title={translate('web.buyerDetails', 'Buyer Details')}>
                    <div className={eformInput}>
                        <NetaqInput
                            type='text'
                            label={translate('web.buyerNameEn', 'Buyer Name En')}
                            name='buyerName'
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className={eformInput}>
                        <NetaqInput
                            type='text'
                            label={translate('web.buyerNameAr', 'Buyer Name Ar')}
                            name='buyerName'
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className={eformInput}>
                        <NetaqInput
                            type='email'
                            label={translate('web.buyerEmail', 'Buyer Email')}
                            name='buyerEmail'
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className={eformInput}>
                        <NetaqInput
                            type='phone'
                            label={translate('web.contactNumber', 'Contact Number')}
                            name='buyerPhone'
                            onChange={setPhoneNumber}
                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                            required
                        />
                        {!isPhoneNumberValid &&
                            <div className='text-danger'>
                                {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                            </div>}
                    </div>
                </EahsForm>
            }
            <EahsForm key={'mareDetails'} title={translate('web.mareDetails', 'Mare Details')}>
                <div className={eformInput}>
                    <NetaqInput
                        name='isMareRegisterd'
                        type='select'
                        listSelect={yesNoOptions}
                        label={translate('web.isMareRegistered', 'Is Mare Registered')}
                        value={yesNoOptions.find((item) => item.value == mareData?.isRegisterd)}
                        onChange={(selected) => {
                            setMareData({
                                ...mareData,
                                isRegisterd: selected?.value
                            })
                        }}
                        required

                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        name='isForExport'
                        type='select'
                        listSelect={yesNoOptions}
                        label={translate('web.isForExport', 'Is Semen For Export?')}
                        value={yesNoOptions.find((item) => item.value == mareData?.isForExport)}
                        onChange={(selected) => {
                            setMareData({
                                ...mareData,
                                isForExport: selected?.value
                            })
                        }}
                        required

                    />
                </div>
                {/* if mare registed So Just selcet it */}
                {mareData?.isRegisterd &&
                    <div className={eformInput}>
                        <label>
                            {translate("web.mare", "Mare")}
                            <i className="colorred"> *</i>
                        </label>
                        <AsyncSelect
                            isClearable
                            loadOptions={(searchKey) => promiseOptions(searchKey, 'Mare', timeoutId, setTimeoutId)}
                            defaultOptions={false}
                            onInputChange={(newValue) => setSearchMare(newValue)}
                            inputValue={searchMare}
                            value={selectedMare}
                            loadingMessage={() => translate("web.loading", "Loading")}
                            onChange={(selected) => {
                                setSelectedMare(selected)
                            }}
                            placeholder={
                                translate("web.typeToSearch", "Type To Search") + "..."
                            }
                            noOptionsMessage={() =>
                                translate("web.noOptions", "No Options")
                            }
                            key={"notMareOwner"}
                        />
                    </div>
                }
                {/* if mare is not registed you need to add Some Detilas :-P */}
                {!mareData?.isRegisterd &&
                    <>

                        <div className={eformInput}>
                            <NetaqInput
                                type='horseName'
                                label={translate('web.mareNameEn', 'Mare Name En')}
                                name='mareName'
                                onChange={handleChange}
                                required

                            />
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                type='horseName'
                                label={translate('web.SireNameEn', 'Sire Name En')}
                                name='sireName'
                                onChange={handleChange}
                                required

                            />
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                type='horseName'
                                label={translate('web.damNameEn', 'Sire Name En')}
                                name='damName'
                                onChange={handleChange}
                                required

                            />
                        </div>
                        <div className={eformInput}>
                            <NetaqInput
                                type='normalDate'
                                label={translate('web.birthDate', 'BirthDate')}
                                name='birthDate'
                                onChange={handleChange}
                                required

                            />
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                name='mareColor'
                                type='select'
                                listSelect={colors}
                                label={translate('web.color', 'Color')}
                                value={colors.find((item) => item.value == mareData?.mareColor)}
                                onChange={(selected) => {
                                    setMareData({
                                        ...mareData,
                                        mareColor: selected?.value
                                    })
                                }}
                                required
                            />
                        </div>
                        <div className={eformInput}>
                            <NetaqInput
                                name='originId'
                                type='select'
                                listSelect={countries}
                                label={translate('web.origin', 'origin')}
                                value={countries.find((item) => item.value == mareData?.originId)}
                                onChange={(selected) => {
                                    setMareData({
                                        ...mareData,
                                        originId: selected?.value
                                    })
                                }}
                                required
                            />
                        </div>
                        <div className={eformInput}>
                            <label className="capatalize_text">
                                {translate('web.horsePassport', 'Horse Passport')} <span className="color-eahsred" >*</span>
                            </label>
                            <SimpleUpload accept="image/*,application/pdf" isMulti={false} isServer={false} initialFiles={horsePassport} onChange={(e) => handleUpload(e, setHorsePassport)} key={'horsePassport'} />

                        </div>

                    </>
                }

            </EahsForm>
            <EahsForm key={'rankss'} title={translate('web.mareRacingResults', 'Mare Racing Results')}>
                <DynamicTableForm key={'DynamicTableForm'} isVIPHorse={isVIPHorse} />
            </EahsForm>
            <EahsForm key={'covering Location'} title={translate('web.coveringLocation', 'Covering Location')} className={'mb-main'}>
                <div className={eformInput}>
                    <NetaqInput
                        name='coveringCountry'
                        type='select'
                        listSelect={countries}
                        label={translate('web.coveringCountry', 'Covering Country')}
                        value={countries.find((item) => item.value == mareData?.coveringCountry)}
                        onChange={(selected) => {
                            debugger;
                            setMareData({
                                ...mareData,
                                coveringCountry: selected?.value
                            })
                        }}
                        required
                    />
                </div>
                <div className={'col-md-3 col-sm-12 col-12 mb-form-group'}>
                    <NetaqInput
                        type='text'
                        label={translate('web.centerName', 'Center Name')}
                        name='centerName'
                        onChange={handleChange}
                        required={coveringCountryIsFrance}
                    />
                </div>
                <div className={'col-md-3 col-sm-12 col-12 mb-form-group'}>
                    <NetaqInput
                        type='text'
                        label={translate('web.centerNumber', 'Center Number')}
                        name='centerNumber'
                        onChange={handleChange}
                        required={coveringCountryIsFrance}

                    />
                </div>
            </EahsForm>
            <div className={eformTerms}>
                <CustomPopUp
                    key={'accept Contract'}
                    trigger={
                        <NetaqInput
                            key={'acceptContract'}
                            type='checkbox'
                            name='acceptContract'
                            label={translate('web.acceptContract', 'Accept Contract')}
                            checked={
                                acceptTerms
                            }
                            onChange={(e) => setAcceptTerms(e.target.checked)}
                        />
                    }
                    title={translate('web.acceptContract', 'Accept Contract')}
                    isPdf
                    content={
                        <>
                            <Worker workerUrl={workerURl}>
                                <div
                                    style={{
                                        border: '1px solid rgba(0, 0, 0, 0.3)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        position: 'relative'
                                    }}
                                >
                                    <div
                                        style={{
                                            flex: 1,
                                            overflowY: 'auto',
                                        }}
                                    >
                                        <Viewer
                                            renderLoader={(percentages) => (
                                                <div style={{ width: '100%' }}>
                                                    <ProgressBar progress={Math.round(percentages)} />
                                                </div>
                                            )}
                                            fileUrl={`${BaseURL}/assets/pdf/test.pdf`} plugins={[defaultLayoutPluginInstance]} />
                                    </div>
                                </div>
                            </Worker>
                        </>
                    }
                />
            </div>
            <div className={eFormButtonsContainer}>

                {/* submit btn */}
                <div className={eformFormButton}>
                    <NewActionButton
                        classNames="btn-danger"
                        text={
                            <>
                                <i className="fa-solid fa-circle-check"></i>
                                {isVIPHorse ? translate("web.sendToApprove", "Send To Approve") : translate("web.submitAndPay", "Submit And Pay")}
                            </>
                        }
                        disabled={!acceptTerms}
                    />
                </div>
            </div>

        </div>
    )
    function detailsRow(icon = '', key = "", value = "", classNames = "") {
        return <div className={iconContainer + ' ' + classNames}>
            <i className={`${icon} C89C66`} />
            <span className='fw-bold' >{translate(key, key)} {!!value
                ? value
                : translate("web.unknown", "unknown")} </span>
        </div>;
    }
}
